<template>
  <div class="app-container pb-50px">
    <el-card shadow="never">
      <el-page-header
        :content="identity ? '编辑管理' : '新增管理'"
        @back="$router.back()"
      ></el-page-header>
    </el-card>
    <el-card class="mt-16px" v-loading="loading" shadow="never">
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        size="small"
        label-width="100px"
      >
        <el-form-item label="管理账号" prop="account">
          <el-input
            v-model="form.account"
            :disabled="form.root == 1"
            style="width: 480px"
            show-word-limit
            placeholder="请输入管理账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="管理名称" prop="name">
          <el-input
            v-model="form.name"
            style="width: 480px"
            show-word-limit
            placeholder="请输入管理名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="form.password"
            style="width: 480px"
            show-password
            clearable
            placeholder="请输入密码"
          />
        </el-form-item>

        <el-form-item label="确认密码" prop="password_confirm">
          <el-input
            v-model="form.password_confirm"
            style="width: 480px"
            show-password
            clearable
            placeholder="请输入确认密码"
          />
        </el-form-item>

        <el-form-item label="管理状态" v-if="form.root != 1">
          <el-switch
            v-model="form.status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="停用"
          />
        </el-form-item>
        <el-form-item label="管理权限" v-if="form.root != 1">
          <div class="permission-panel">
            <div
              class="permission-row"
              v-for="item in permissionOptions"
              :key="item.module_key"
            >
              <div class="permission-row__title">{{ item.module_name }}</div>
              <el-checkbox-group v-model="form.permissions">
                <el-checkbox
                  v-for="action in item.actions"
                  :key="item.module_key + '.' + action.action_key"
                  :label="item.module_key + '.' + action.action_key"
                >
                  {{ action.action_name }}
                  <span
                    v-if="
                      permissionActionTip(item.module_key, action.action_key)
                    "
                    class="permission-action-tip"
                  >
                    {{
                      permissionActionTip(item.module_key, action.action_key)
                    }}
                  </span>
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="form-tips">新增普通管理员默认无权限，需要手动勾选。</div>
        </el-form-item>
      </el-form>
    </el-card>
    <footer-wrap>
      <el-button size="small" @click="$router.back()">取 消</el-button>
      <el-button v-if="canSave" type="primary" size="small" @click="onSubmit">
        保 存
      </el-button>
    </footer-wrap>
  </div>
</template>

<script>
import FooterWrap from "@/components/footer-wrap/index.vue";

import {
  apiDetailAdministrator,
  apiAddAdministrator,
  apiEditAdministrator,
  apiAdministratorPermissionOptions,
} from "@/api/perm";

export default {
  components: {
    FooterWrap,
  },
  data() {
    const passwordConfirmValidator = (rule, value, callback) => {
      if (this.form.password) {
        if (!value) callback(new Error("请再次输入密码"));
        if (value !== this.form.password)
          callback(new Error("两次输入密码不一致!"));
      }
      callback();
    };
    return {
      identity: null,
      loading: false,
      form: {
        id: "",
        account: "",
        name: "",
        password: "",
        password_confirm: "",
        status: 0,
        root: 0,
        permissions: [],
      },
      permissionOptions: [],
      rules: {
        account: [
          { required: true, trigger: "blur", message: "请输入管理账号" },
        ],
        name: [{ required: true, trigger: "blur", message: "请输入管理名称" }],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: ["blur"],
          },
        ],
        password_confirm: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: ["blur"],
          },
          {
            validator: passwordConfirmValidator,
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.identity = this.$route.query.id;
    this.getPermissionOptions();
    this.identity && this.getDetail();
  },
  computed: {
    canSave() {
      return this.identity
        ? this.$hasPermission("system.admin", "edit")
        : this.$hasPermission("system.admin", "create");
    },
  },
  methods: {
    getPermissionOptions() {
      apiAdministratorPermissionOptions().then((resp) => {
        this.permissionOptions = resp || [];
      });
    },
    getDetail() {
      this.loading = true;
      apiDetailAdministrator({ id: this.identity }).then((resp) => {
        Object.keys(resp).map((item) => {
          this.$set(this.form, item, resp[item]);
        });
        this.form.permissions = resp.permissions || [];
        this.rules.password = [];
        this.rules.password_confirm = [
          {
            validator: this.passwordConfirmValidator,
            trigger: "blur",
          },
        ];
        this.loading = false;
      });
    },
    onSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        if (this.identity) {
          apiEditAdministrator({ ...this.form, id: this.identity }).then(() => {
            this.$router.back();
          });
        } else {
          apiAddAdministrator(this.form).then(() => {
            this.$router.back();
          });
        }
      });
    },
    permissionActionTip(moduleKey, actionKey) {
      if (moduleKey === "seo.keyword" && actionKey === "edit") {
        return "含手动诊断、站点同步排名";
      }
      if (moduleKey === "seo.setting" && actionKey === "edit") {
        return "含立即同步排名";
      }
      if (moduleKey === "seo.auto_run" && actionKey === "sync") {
        return "含重试、补提交、手动采集";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.permission-panel {
  width: 640px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.permission-row {
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: 8px 14px;
  border-bottom: 1px solid #ebeef5;

  &:last-child {
    border-bottom: none;
  }

  &__title {
    width: 180px;
    color: #606266;
  }
}

.form-tips {
  margin-top: 8px;
  color: #909399;
  font-size: 12px;
}

.permission-action-tip {
  margin-left: 6px;
  color: #909399;
  font-size: 12px;
}
</style>
